import {
  submitHsaAnswerInput,
  submitHsaAnswerOutput,
} from "@redotech/redo-conversion-hsa-common/rpc-schemas/submit-hsa-answer";
import { unaryRpc } from "@redotech/rpc/definition";

// Per-question incremental save. The answer carries its own
// `questionHandle`, so the input doesn't repeat it. Idempotent on
// (session_id, question_handle): re-submitting overwrites the row.
export const submitHsaAnswer = unaryRpc({
  name: "submitHsaAnswer",
  input: submitHsaAnswerInput,
  output: submitHsaAnswerOutput,
});
